import { Form } from 'react-final-form'

import { SafetyCaseForm as SafetyCaseFormComponent } from '../../../components'

const SafetyCaseForm = (props: any) => {
  const { onSubmit, initialValues, formName, additionalOptions, baseStatus, setForm, onChange, disabled, isViewMode } =
    props

  return (
    <Form
      onSubmit={onSubmit}
      initialValues={initialValues}
      component={SafetyCaseFormComponent}
      formName={formName}
      baseStatus={baseStatus}
      additionalOptions={additionalOptions}
      setForm={setForm}
      onChange={onChange}
      disabled={disabled}
      isViewMode={isViewMode}
      mutators={{
      addSelectedTagIds: (args, state, utils) => {
        utils.changeValue(state, 'tagIds', () => {
          const prevIds = state.lastFormState?.values.tagIds || []
          return [...prevIds, ...args[0]]
        })
      },
    }}
      keepDirtyOnReinitialize
    />
  )
}

export default SafetyCaseForm
